import { VacancyCreatePage } from '@pages/vacancy';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Создание вакансии', 'Создание новой вакансии');
}

export default VacancyCreatePage;
